var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96459 4.84319L5.99991 4.87851L6.03527 4.84323L10.5958 0.291999L10.5959 0.291963C10.9061 -0.0182965 11.4071 -0.018343 11.7173 0.291908C12.0183 0.592947 12.0183 1.10305 11.7173 1.40409L7.15676 5.96465L7.1214 6L7.15676 6.03536L11.7173 10.5959C12.0276 10.9062 12.0276 11.4071 11.7173 11.7173C11.4071 12.0276 10.9062 12.0276 10.5959 11.7173L6.03536 7.15676L6 7.1214L5.96465 7.15676L1.40409 11.7173C1.09384 12.0276 0.592947 12.0276 0.282692 11.7173C-0.0275639 11.4071 -0.0275639 10.9062 0.282692 10.5959L4.84324 6.03536L4.8786 6L4.84324 5.96465L0.282692 1.40409C-0.0275639 1.09384 -0.0275639 0.592947 0.282692 0.282692C0.592947 -0.0275639 1.09384 -0.0275639 1.40409 0.282692L5.96459 4.84319Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/cross-mark.e87bbae676a02fe1675f1f4dc40eadac.svg";
export { ForwardRef as ReactComponent };